import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['providerIdInput', 'linkInput']

  connect() {
    const checkedRadio = this.element.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      checkedRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  update(event) {
    const { providerId, link } = event.params

    if (event.currentTarget.checked) {
      if (this.hasProviderIdInputTarget) {
        this.providerIdInputTarget.value = providerId
      }
      if (this.hasLinkInputTarget) {
        this.linkInputTarget.value = link
      }
    }
  }
}
